import React from 'react';

import { Spin } from 'antd';

function Loading() {
    return (
        <div className="loader">
            <Spin tip="Loading"></Spin>
        </div>
    );
}

export default Loading;
